import { SortableFilter }          from './../common/sortable-filter';

export class DynamicReportFilter extends SortableFilter {
    public ReportName: string;

    public Parameters: Array<any>;

    public Timeout = 600000;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/monitoring/dynamic-report-filter.ts